import axios from 'axios';
import { SNACKBAR_ERRORS } from './constants';

export const getVideoMetadataErrors = (video) => {
  const minRequiredWidht = 1152;
  const aspectRatio = video.videoWidth / video.videoHeight;
  const isVertical = aspectRatio < 1;

  if (!video.HAVE_METADATA) {
    return SNACKBAR_ERRORS.FILE_NOT_VALID_ERROR;
  }

  if (isVertical) {
    return SNACKBAR_ERRORS.WRONG_VIDEO_POSITION_ERROR;
  }
  if (video.videoWidth < minRequiredWidht) {
    return SNACKBAR_ERRORS.WRONG_VIDEO_WIDTH_ERROR;
  }

  return null;
};

const isFileNameAVideo = (fileName) =>
  /\.(mp4|mov|avi|mkv|flv|wmv|webm|3gp|ogg|ogv|mpg|mpeg|m4v)$/i.test(fileName);

export const getVideoFileNameErrors = (file) => {
  if (!file) {
    return SNACKBAR_ERRORS.FILE_NOT_VALID_ERROR;
  }

  if (!isFileNameAVideo(file.name)) {
    return SNACKBAR_ERRORS.UNSUPORTED_VIDEO_ERROR;
  }

  return null;
};

const pastTrackedStatus = [];
export const uploadVideoStatusTime = async (status, elapsedTime, fileLength, fileName) => {
  const statusHash = `${status}-${fileName}`;
  if (pastTrackedStatus.includes(statusHash)) {
    return;
  }
  pastTrackedStatus.push(statusHash);
  const url = '/kodak-api/api/v1/media/videos/track-status';

  await axios.post(url, {
    status,
    elapsedTime,
    fileLength,
    fileName,
  });
};
